import { SVGProps } from 'react'

const GlobalMaxRedeemIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M16.65 11.98C16.65 16.4811 13.0011 20.13 8.5 20.13C3.99888 20.13 0.35 16.4811 0.35 11.98C0.35 7.47887 3.99888 3.82998 8.5 3.82998C13.0011 3.82998 16.65 7.47887 16.65 11.98Z"
      stroke="currentColor"
      strokeWidth="0.7"
    />
    <path
      d="M23.58 11.98C23.58 16.4811 19.9311 20.13 15.43 20.13C10.9289 20.13 7.27999 16.4811 7.27999 11.98C7.27999 7.47887 10.9289 3.82998 15.43 3.82998C19.9311 3.82998 23.58 7.47887 23.58 11.98Z"
      stroke="currentColor"
      strokeWidth="0.7"
    />
    <mask id="path-3-inside-1_10277_2817" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9651 19.744C14.9323 18.4177 17 15.4403 17 11.98C17 8.51974 14.9323 5.54237 11.9651 4.21606C8.99786 5.54237 6.93018 8.51974 6.93018 11.98C6.93018 15.4403 8.99786 18.4177 11.9651 19.744Z"
      />
    </mask>
    <path
      d="M11.9651 19.744L11.6794 20.3831L11.9651 20.5108L12.2507 20.3831L11.9651 19.744ZM11.9651 4.21606L12.2507 3.577L11.9651 3.44932L11.6794 3.577L11.9651 4.21606ZM16.3 11.98C16.3 15.1543 14.4038 17.8872 11.6794 19.1049L12.2507 20.3831C15.4608 18.9482 17.7 15.7264 17.7 11.98H16.3ZM11.6794 4.85513C14.4038 6.07288 16.3 8.80578 16.3 11.98H17.7C17.7 8.23369 15.4608 5.01185 12.2507 3.577L11.6794 4.85513ZM7.63018 11.98C7.63018 8.80578 9.52636 6.07288 12.2507 4.85513L11.6794 3.577C8.46936 5.01185 6.23018 8.23369 6.23018 11.98H7.63018ZM12.2507 19.1049C9.52636 17.8872 7.63018 15.1543 7.63018 11.98H6.23018C6.23018 15.7264 8.46936 18.9482 11.6794 20.3831L12.2507 19.1049Z"
      fill="#FF0000"
      mask="url(#path-3-inside-1_10277_2817)"
    />
    <line
      x1="8.41187"
      y1="15.9583"
      x2="15.4119"
      y2="15.9583"
      stroke="currentColor"
      strokeWidth="0.333334"
    />
    <line
      x1="7.41174"
      y1="14.4583"
      x2="16.4117"
      y2="14.4583"
      stroke="currentColor"
      strokeWidth="0.333334"
    />
    <line
      x1="7.41174"
      y1="12.9583"
      x2="16.4117"
      y2="12.9583"
      stroke="currentColor"
      strokeWidth="0.333334"
    />
    <line
      x1="7.41174"
      y1="11.4583"
      x2="16.4117"
      y2="11.4583"
      stroke="currentColor"
      strokeWidth="0.333334"
    />
    <line
      x1="7.41174"
      y1="9.95833"
      x2="16.4117"
      y2="9.95833"
      stroke="currentColor"
      strokeWidth="0.333334"
    />
    <line
      x1="7.91162"
      y1="8.45833"
      x2="15.9116"
      y2="8.45833"
      stroke="currentColor"
      strokeWidth="0.333334"
    />
    <line
      x1="8.91174"
      y1="6.95833"
      x2="15.0617"
      y2="6.95833"
      stroke="currentColor"
      strokeWidth="0.333334"
    />
    <line
      x1="9.41162"
      y1="17.4583"
      x2="14.4116"
      y2="17.4583"
      stroke="currentColor"
      strokeWidth="0.333334"
    />
    <rect x="11.25" y="-1.50122" width="0.75" height="25.5" fill="#FF0000" />
  </svg>
)
export default GlobalMaxRedeemIcon
